import { cn } from '@/lib/utils'
import { HelpCircleIcon } from 'lucide-react'
import React from 'react'
import { match } from 'ts-pattern'
import ButtonBase from './Button/ButtonBase'
import {
    Popover,
    PopoverAnchor,
    PopoverContent,
    PopoverTrigger,
} from './ui/popover'

interface IProps {
    children?: React.ReactNode
    size?: 'small' | 'medium' | 'large'
    Icon?: React.ReactElement
    /** className passado para o popover trigger */
    className?: string
    borderless?: boolean
    forceEnabled?: boolean
}

export default function IconeAjuda({
    children,
    size,
    Icon,
    className,
    borderless,
    forceEnabled = false,
}: IProps) {
    const sizeClass = match(size)
        .with('small', () => '[&_svg]:size-4 p-1.5')
        .with('large', () => '[&_svg]:size-8 p-3')
        .otherwise(() => '[&_svg]:size-6 p-2')

    Icon ??= <HelpCircleIcon />

    const [open, setOpen] = React.useState(false)

    function handleOpenChange() {
        setTimeout(() => {
            setOpen(!open)
        }, 150)
    }

    return (
        <Popover open={open} onOpenChange={handleOpenChange}>
            <PopoverTrigger asChild>
                <PopoverAnchor
                    className={cn({
                        'group-aria-disabled:pointer-events-none':
                            !forceEnabled,
                    })}
                >
                    <ButtonBase
                        variant="ghost"
                        size="icon"
                        className={cn(
                            sizeClass,
                            'rounded-full text-foreground hover:text-foreground size-fit',
                            className,
                        )}
                    >
                        {Icon}
                    </ButtonBase>
                </PopoverAnchor>
            </PopoverTrigger>

            <PopoverContent
                collisionPadding={8}
                className={cn('text-left', {
                    'p-0 border-0': borderless,
                })}
            >
                {/* Rola dentro do popover em vez de vazar da tela; o scroll fica
                    num wrapper para não cortar a seta, que é filha do Content. */}
                <div className="max-h-[calc(var(--radix-popover-content-available-height)_-_2rem_-_2px)] overflow-y-auto">
                    {children}
                </div>
            </PopoverContent>
        </Popover>
    )
}
